__webpack_public_path__ = `${window.__CONFIG__?.publicPathPrefix}/assets/`
